import { createReducer, on, Action } from '@ngrx/store';

import * as FullscreenLoaderActions from './fullscreen-loader.actions';
import { FullscreenLoaderModel } from './fullscreen-loader.model';
import { FullScreenLoaderEnum } from '@enums/fullscreen-loader.enum';

const initialState: FullscreenLoaderModel = new FullscreenLoaderModel();

const reducer = createReducer(
  initialState,
  on(
    FullscreenLoaderActions.setVisibility,
    (state, { isVisible, loaderType, contentfulMessageKey, contentfulBody }) =>
      ({
        isVisible,
        loaderType: loaderType || FullScreenLoaderEnum.DEFAULT,
        contentfulMessageKey: contentfulMessageKey,
        contentfulBody: contentfulBody,
      } as FullscreenLoaderModel)
  )
);

export function fullscreenLoaderReducer(state: FullscreenLoaderModel, action: Action) {
  return reducer(state, action);
}
